import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type PageDetailsFragment = {
  __typename?: 'EventPage';
  id: string;
  pageTitle: string;
  disabled: boolean;
  type: Types.EventPageType;
  pageKind: Types.PageKind;
  pageSlug: string;
  visibility: Types.EventPageVisibility;
  private: boolean;
  isPageContainer: boolean;
  photoV2?:
    | { __typename?: 'DefaultPagePhoto'; id: string; height: number; width: number; url: string; layout: { __typename?: 'DefaultPagePhotoLayout'; alignX: string; alignY: string } }
    | { __typename?: 'Photo'; id: string; height: number; width: number; url: string; layout: { __typename?: 'PhotoLayout'; alignX: string; alignY: string } }
    | null;
  createdAt: { __typename?: 'Date'; timestamp: any };
  photoPresentation?: {
    __typename?: 'WebsitePagePhotoPresentation';
    id: string;
    presentationLayout: string;
    cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo'; height: number; unit: string; width: number; x: number; y: number } | null;
  } | null;
};

export type WebsiteInfoQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
  purpose?: Types.InputMaybe<Types.EventDesignPurpose>;
}>;

export type WebsiteInfoQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    photoV2Url?: string | null;
    firebaseId: string;
    hasMobilePhoto: boolean;
    photoV2UrlMobile?: string | null;
    websiteState: Types.EventWebsiteState;
    photo?: { __typename?: 'Photo'; id: string; url: string } | null;
    eventDesign?: { __typename?: 'EventDesign'; id: string; websiteLayout: { __typename?: 'DesignLayout'; id: string; layoutType: Types.DesignLayoutType } } | null;
    liveEventDesign?: {
      __typename?: 'EventDesign';
      id: string;
      brannanNavigation: Types.BrannanNavigation;
      theme: { __typename?: 'Theme'; id: string; themeId: string };
      websiteLayout: { __typename?: 'DesignLayout'; id: string; layoutType: Types.DesignLayoutType };
      activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings'; schemaURL: string; websiteLayout: string; dataJSON: any; id: string } | null;
    } | null;
    info: {
      __typename?: 'EventInfo';
      id: string;
      eventPassword?: string | null;
      safetyRating?: Types.SafetyRating | null;
      announcementBanner: { __typename?: 'EventAnnouncementBanner'; title: string; message: string; active: boolean };
      schedule: {
        __typename?: 'EventScheduleInfo';
        id: string;
        items: Array<{ __typename?: 'EventSchedule'; id: string; name: string; isMain: boolean; startTime?: { __typename?: 'Date'; timestamp: any; timezone: string } | null }>;
      };
      finalizedDate?: { __typename?: 'Date'; timezone: string; milliseconds: number; dateString: string } | null;
    };
    pages: Array<{
      __typename?: 'EventPage';
      id: string;
      pageTitle: string;
      disabled: boolean;
      type: Types.EventPageType;
      pageKind: Types.PageKind;
      pageSlug: string;
      visibility: Types.EventPageVisibility;
      private: boolean;
      isPageContainer: boolean;
      photoV2?:
        | {
            __typename?: 'DefaultPagePhoto';
            id: string;
            height: number;
            width: number;
            url: string;
            layout: { __typename?: 'DefaultPagePhotoLayout'; alignX: string; alignY: string };
          }
        | { __typename?: 'Photo'; id: string; height: number; width: number; url: string; layout: { __typename?: 'PhotoLayout'; alignX: string; alignY: string } }
        | null;
      createdAt: { __typename?: 'Date'; timestamp: any };
      photoPresentation?: {
        __typename?: 'WebsitePagePhotoPresentation';
        id: string;
        presentationLayout: string;
        cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo'; height: number; unit: string; width: number; x: number; y: number } | null;
      } | null;
    }>;
    mobilePhoto?: { __typename?: 'Photo'; id: string; container: string; url: string } | null;
    pageContainers?: Array<{
      __typename?: 'PageContainer';
      id: string;
      slug: string;
      visibility: Types.EventPageVisibility;
      mainPhotoPresentationLayout?: string | null;
      mainPhotoAlignment?: { __typename?: 'PhotoAlignmentValue'; x: Types.PhotoXPosition; y: Types.PhotoYPosition } | null;
      mainPhotoCropInfo?: { __typename?: 'MainPhotoCropInfo'; unit: string; height: number; width: number; x: number; y: number } | null;
    }> | null;
  } | null;
  me?: { __typename?: 'User'; id: string; emailIsVerified: boolean } | null;
};

export type UpdateEventSettingsMutationVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  payload: Types.UpdateEventSettingsPayload;
}>;

export type UpdateEventSettingsMutation = {
  __typename?: 'Mutation';
  updateEventSettings: {
    __typename?: 'EventSettings';
    id: string;
    requirePasswordForEventDate: boolean;
    requirePasswordForEventLocation: boolean;
    hideDownloadAppPage: boolean;
    hideEventCountdown: boolean;
    hideFromJoySearch: boolean;
    hideFromSearchEngines: boolean;
  };
};

export type ReorderEventPagesMutationVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  payload: Array<Types.ModelReorderPayload> | Types.ModelReorderPayload;
}>;

export type ReorderEventPagesMutation = {
  __typename?: 'Mutation';
  reorderEventPages: Array<{
    __typename?: 'EventPage';
    id: string;
    pageTitle: string;
    disabled: boolean;
    type: Types.EventPageType;
    pageKind: Types.PageKind;
    pageSlug: string;
    visibility: Types.EventPageVisibility;
    private: boolean;
    isPageContainer: boolean;
    photoV2?:
      | {
          __typename?: 'DefaultPagePhoto';
          id: string;
          height: number;
          width: number;
          url: string;
          layout: { __typename?: 'DefaultPagePhotoLayout'; alignX: string; alignY: string };
        }
      | { __typename?: 'Photo'; id: string; height: number; width: number; url: string; layout: { __typename?: 'PhotoLayout'; alignX: string; alignY: string } }
      | null;
    createdAt: { __typename?: 'Date'; timestamp: any };
    photoPresentation?: {
      __typename?: 'WebsitePagePhotoPresentation';
      id: string;
      presentationLayout: string;
      cropInfo?: { __typename?: 'WebsitePagePhotoPresentationCropInfo'; height: number; unit: string; width: number; x: number; y: number } | null;
    } | null;
  }>;
};

export type BatchUpdateEventPagesVisibilityMutationVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  payloads: Array<Types.BatchUpdateEventPagesPayload> | Types.BatchUpdateEventPagesPayload;
}>;

export type BatchUpdateEventPagesVisibilityMutation = {
  __typename?: 'Mutation';
  batchUpdateEventPages: Array<{ __typename?: 'EventPage'; id: string; visibility: Types.EventPageVisibility; type: Types.EventPageType; pageTitle: string }>;
};

export type UpdateEventInfoSettingsMutationVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  payload: Types.UpdateEventInfoPayload;
}>;

export type UpdateEventInfoSettingsMutation = {
  __typename?: 'Mutation';
  updateEventInfo: {
    __typename?: 'EventInfo';
    id: string;
    fianceeFirstName?: string | null;
    fianceeLastName?: string | null;
    eventDisplayName?: string | null;
    ownerFirstName?: string | null;
    ownerLastName?: string | null;
    eventDateIsFinalized: boolean;
    timezone?: string | null;
    locale: string;
    announcementBanner: { __typename?: 'EventAnnouncementBanner'; active: boolean; message: string; title: string };
    tentativeDate?: { __typename?: 'Date'; timezone: string; milliseconds: number; dateString: string } | null;
    finalizedDate?: { __typename?: 'Date'; timezone: string; milliseconds: number; dateString: string } | null;
    locationInfo?: {
      __typename?: 'EventLocation';
      id?: string | null;
      placeId?: string | null;
      name?: string | null;
      latitude?: number | null;
      longitude?: number | null;
      state?: string | null;
      city?: string | null;
      country?: string | null;
    } | null;
  };
};

export type GeneralSettingsInfoQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type GeneralSettingsInfoQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    domain?: { __typename?: 'EventDomain'; id: string; domainName: string } | null;
    info: {
      __typename?: 'EventInfo';
      id: string;
      fianceeFirstName?: string | null;
      fianceeLastName?: string | null;
      ownerFirstName?: string | null;
      ownerLastName?: string | null;
      eventDisplayName?: string | null;
      eventDateIsFinalized: boolean;
      timezone?: string | null;
      locale: string;
      finalizedDate?: { __typename?: 'Date'; timezone: string; milliseconds: number; dateString: string } | null;
      tentativeDate?: { __typename?: 'Date'; timezone: string; milliseconds: number; dateString: string } | null;
      locationInfo?: {
        __typename?: 'EventLocation';
        id?: string | null;
        placeId?: string | null;
        name?: string | null;
        latitude?: number | null;
        longitude?: number | null;
        state?: string | null;
        city?: string | null;
        country?: string | null;
      } | null;
    };
  } | null;
};

export type SetEventAssetMutationVariables = Types.Exact<{
  setEventAssetId: Types.Scalars['ID'];
  payload: Types.SetAssetPayload;
  isMobile?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;

export type SetEventAssetMutation = {
  __typename?: 'Mutation';
  setEventAsset: { __typename?: 'Event'; id: string; hasMobilePhoto: boolean; mobilePhoto?: { __typename?: 'Photo'; id: string; url: string; container: string } | null };
};

export type DeleteEventAssetMutationVariables = Types.Exact<{
  deleteEventAssetId: Types.Scalars['ID'];
  isMobile?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;

export type DeleteEventAssetMutation = {
  __typename?: 'Mutation';
  deleteEventAsset: { __typename?: 'Event'; id: string; hasMobilePhoto: boolean; mobilePhoto?: { __typename?: 'Photo'; id: string; url: string; container: string } | null };
};

export type UpdateMainEventScheduleMutationVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  eventInfoPayload: Types.UpdateEventInfoPayload;
  scheduleId: Types.Scalars['ID'];
  updateSettings: Types.Scalars['Boolean'];
  eventSettingsPayload: Types.UpdateEventSettingsPayload;
}>;

export type UpdateMainEventScheduleMutation = {
  __typename?: 'Mutation';
  updateEventInfo: {
    __typename?: 'EventInfo';
    id: string;
    eventDateIsFinalized: boolean;
    tentativeDate?: { __typename?: 'Date'; milliseconds: number; timezone: string; dateString: string } | null;
    finalizedDate?: { __typename?: 'Date'; timezone: string; milliseconds: number; dateString: string } | null;
  };
  setMainEventSchedule: { __typename?: 'EventSchedule'; id: string; name: string };
  updateEventSettings?: { __typename?: 'EventSettings'; id: string; hideEventCountdown: boolean };
};

export type UpdateEventDateMutationVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  payload: Types.UpdateEventInfoPayload;
}>;

export type UpdateEventDateMutation = {
  __typename?: 'Mutation';
  updateEventInfo: {
    __typename?: 'EventInfo';
    id: string;
    eventDateIsFinalized: boolean;
    timezone?: string | null;
    tentativeDate?: { __typename?: 'Date'; timezone: string; milliseconds: number; dateString: string } | null;
    finalizedDate?: { __typename?: 'Date'; timezone: string; milliseconds: number; dateString: string; timeString: string } | null;
  };
  unsetMainEventSchedule?: { __typename?: 'EventSchedule'; id: string } | null;
};

export type TravelSettingsMapComponentFragment = { __typename: 'TravelMapComponent'; id: string; sortOrder: number; hideExploreCTA: boolean };

export type SettingsPageContainerBySlugQueryVariables = Types.Exact<{
  eventName: Types.Scalars['String'];
  pageSlug: Types.Scalars['String'];
}>;

export type SettingsPageContainerBySlugQuery = {
  __typename?: 'Query';
  pageContainerBySlug?: {
    __typename?: 'PageContainer';
    id: string;
    components?: Array<
      | { __typename?: 'EventCountdownComponent' }
      | { __typename?: 'EventDetailsComponent' }
      | { __typename?: 'EventDisplayNameComponent' }
      | { __typename?: 'GreetingMessageComponent' }
      | { __typename?: 'JsonDataBlobComponent' }
      | { __typename?: 'MediaGalleryComponent' }
      | { __typename?: 'PhotoComponent' }
      | { __typename?: 'RsvpAndUnlockGuestDetailsButtonComponent' }
      | { __typename?: 'TextComponent' }
      | { __typename: 'TravelMapComponent'; id: string; sortOrder: number; hideExploreCTA: boolean }
      | { __typename?: 'VideoComponent' }
    > | null;
  } | null;
  eventByName?: {
    __typename?: 'Event';
    id: string;
    travelSettings?: {
      __typename?: 'TravelSettings';
      currencyCode?: Types.TravelCurrencyCode | null;
      checkInDate?: string | null;
      checkOutDate?: string | null;
      datesMatchingReminder?: boolean | null;
    } | null;
  } | null;
};

export type SetEventPhotoV2UrlMobileMutationVariables = Types.Exact<{
  payload: Types.SetEventPhotoV2MobilePayload;
}>;

export type SetEventPhotoV2UrlMobileMutation = { __typename?: 'Mutation'; setEventPhotoV2UrlMobile: { __typename?: 'Event'; id: string; photoV2UrlMobile?: string | null } };

export const PageDetailsFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PageDetails' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventPage' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'disabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photoV2' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Photo' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'layout' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'alignX' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'alignY' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DefaultPagePhoto' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'layout' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'alignX' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'alignY' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageKind' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'timestamp' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'pageSlug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
          { kind: 'Field', name: { kind: 'Name', value: 'private' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPageContainer' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photoPresentation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cropInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'presentationLayout' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const TravelSettingsMapComponentFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TravelSettingsMapComponent' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelMapComponent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideExploreCTA' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const WebsiteInfoDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WebsiteInfo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'purpose' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesignPurpose' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'photoV2Url' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eventDesign' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'purpose' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'purpose' } } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'websiteLayout' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'layoutType' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'liveEventDesign' },
                  name: { kind: 'Name', value: 'eventDesign' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'purpose' }, value: { kind: 'EnumValue', value: 'live' } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'theme' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'themeId' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'websiteLayout' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'layoutType' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'activeWebsiteHeaderPresentationLayout' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', alias: { kind: 'Name', value: 'id' }, name: { kind: 'Name', value: 'eventId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'schemaURL' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'websiteLayout' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dataJSON' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'brannanNavigation' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'admin' }, value: { kind: 'BooleanValue', value: true } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventPassword' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'safetyRating' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'announcementBanner' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'schedule' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'items' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'startTime' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isMain' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'finalizedDate' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dateString' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pages' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'admin' }, value: { kind: 'BooleanValue', value: true } }],
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PageDetails' } }] },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'firebaseId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMobilePhoto' } },
                { kind: 'Field', name: { kind: 'Name', value: 'photoV2UrlMobile' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mobilePhoto' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'container' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageContainers' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'admin' }, value: { kind: 'BooleanValue', value: true } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mainPhotoAlignment' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                          ],
                        },
                      },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomPagePhotoPresentationInfo' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'websiteState' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'emailIsVerified' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'liveQuery' }, value: { kind: 'BooleanValue', value: true } }],
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PageDetails' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventPage' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'disabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photoV2' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Photo' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'layout' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'alignX' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'alignY' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DefaultPagePhoto' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'layout' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'alignX' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'alignY' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageKind' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'timestamp' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'pageSlug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
          { kind: 'Field', name: { kind: 'Name', value: 'private' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPageContainer' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photoPresentation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cropInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'presentationLayout' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomPagePhotoPresentationInfo' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PageContainer' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mainPhotoCropInfo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                { kind: 'Field', name: { kind: 'Name', value: 'y' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'mainPhotoPresentationLayout' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useWebsiteInfoQuery__
 *
 * To run a query within a React component, call `useWebsiteInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteInfoQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *      purpose: // value for 'purpose'
 *   },
 * });
 */
export function useWebsiteInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WebsiteInfoQuery, WebsiteInfoQueryVariables>) {
  return ApolloReactHooks.useQuery<WebsiteInfoQuery, WebsiteInfoQueryVariables>(WebsiteInfoDocument, baseOptions);
}
export function useWebsiteInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebsiteInfoQuery, WebsiteInfoQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<WebsiteInfoQuery, WebsiteInfoQueryVariables>(WebsiteInfoDocument, baseOptions);
}
export type WebsiteInfoQueryHookResult = ReturnType<typeof useWebsiteInfoQuery>;
export type WebsiteInfoLazyQueryHookResult = ReturnType<typeof useWebsiteInfoLazyQuery>;
export type WebsiteInfoQueryResult = Apollo.QueryResult<WebsiteInfoQuery, WebsiteInfoQueryVariables>;
export const UpdateEventSettingsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateEventSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateEventSettingsPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateEventSettings' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requirePasswordForEventDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requirePasswordForEventLocation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hideDownloadAppPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hideEventCountdown' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hideFromJoySearch' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hideFromSearchEngines' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateEventSettingsMutationFn = Apollo.MutationFunction<UpdateEventSettingsMutation, UpdateEventSettingsMutationVariables>;

/**
 * __useUpdateEventSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateEventSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventSettingsMutation, { data, loading, error }] = useUpdateEventSettingsMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateEventSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEventSettingsMutation, UpdateEventSettingsMutationVariables>) {
  return ApolloReactHooks.useMutation<UpdateEventSettingsMutation, UpdateEventSettingsMutationVariables>(UpdateEventSettingsDocument, baseOptions);
}
export type UpdateEventSettingsMutationHookResult = ReturnType<typeof useUpdateEventSettingsMutation>;
export type UpdateEventSettingsMutationResult = Apollo.MutationResult<UpdateEventSettingsMutation>;
export type UpdateEventSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateEventSettingsMutation, UpdateEventSettingsMutationVariables>;
export const ReorderEventPagesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReorderEventPages' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ModelReorderPayload' } } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reorderEventPages' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'payloads' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PageDetails' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PageDetails' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventPage' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'disabled' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photoV2' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Photo' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'layout' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'alignX' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'alignY' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DefaultPagePhoto' } },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'layout' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'alignX' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'alignY' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageKind' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'timestamp' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'pageSlug' } },
          { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
          { kind: 'Field', name: { kind: 'Name', value: 'private' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPageContainer' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photoPresentation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cropInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'height' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'width' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'presentationLayout' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type ReorderEventPagesMutationFn = Apollo.MutationFunction<ReorderEventPagesMutation, ReorderEventPagesMutationVariables>;

/**
 * __useReorderEventPagesMutation__
 *
 * To run a mutation, you first call `useReorderEventPagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderEventPagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderEventPagesMutation, { data, loading, error }] = useReorderEventPagesMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useReorderEventPagesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReorderEventPagesMutation, ReorderEventPagesMutationVariables>) {
  return ApolloReactHooks.useMutation<ReorderEventPagesMutation, ReorderEventPagesMutationVariables>(ReorderEventPagesDocument, baseOptions);
}
export type ReorderEventPagesMutationHookResult = ReturnType<typeof useReorderEventPagesMutation>;
export type ReorderEventPagesMutationResult = Apollo.MutationResult<ReorderEventPagesMutation>;
export type ReorderEventPagesMutationOptions = Apollo.BaseMutationOptions<ReorderEventPagesMutation, ReorderEventPagesMutationVariables>;
export const BatchUpdateEventPagesVisibilityDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BatchUpdateEventPagesVisibility' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payloads' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'ListType', type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BatchUpdateEventPagesPayload' } } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'batchUpdateEventPages' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'payloads' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payloads' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'visibility' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pageTitle' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type BatchUpdateEventPagesVisibilityMutationFn = Apollo.MutationFunction<BatchUpdateEventPagesVisibilityMutation, BatchUpdateEventPagesVisibilityMutationVariables>;

/**
 * __useBatchUpdateEventPagesVisibilityMutation__
 *
 * To run a mutation, you first call `useBatchUpdateEventPagesVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchUpdateEventPagesVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchUpdateEventPagesVisibilityMutation, { data, loading, error }] = useBatchUpdateEventPagesVisibilityMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payloads: // value for 'payloads'
 *   },
 * });
 */
export function useBatchUpdateEventPagesVisibilityMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<BatchUpdateEventPagesVisibilityMutation, BatchUpdateEventPagesVisibilityMutationVariables>,
) {
  return ApolloReactHooks.useMutation<BatchUpdateEventPagesVisibilityMutation, BatchUpdateEventPagesVisibilityMutationVariables>(
    BatchUpdateEventPagesVisibilityDocument,
    baseOptions,
  );
}
export type BatchUpdateEventPagesVisibilityMutationHookResult = ReturnType<typeof useBatchUpdateEventPagesVisibilityMutation>;
export type BatchUpdateEventPagesVisibilityMutationResult = Apollo.MutationResult<BatchUpdateEventPagesVisibilityMutation>;
export type BatchUpdateEventPagesVisibilityMutationOptions = Apollo.BaseMutationOptions<BatchUpdateEventPagesVisibilityMutation, BatchUpdateEventPagesVisibilityMutationVariables>;
export const UpdateEventInfoSettingsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateEventInfoSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateEventInfoPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateEventInfo' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'announcementBanner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'fianceeFirstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fianceeLastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventDisplayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerFirstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownerLastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventDateIsFinalized' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tentativeDate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dateString' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finalizedDate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dateString' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locationInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateEventInfoSettingsMutationFn = Apollo.MutationFunction<UpdateEventInfoSettingsMutation, UpdateEventInfoSettingsMutationVariables>;

/**
 * __useUpdateEventInfoSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateEventInfoSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventInfoSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventInfoSettingsMutation, { data, loading, error }] = useUpdateEventInfoSettingsMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateEventInfoSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEventInfoSettingsMutation, UpdateEventInfoSettingsMutationVariables>) {
  return ApolloReactHooks.useMutation<UpdateEventInfoSettingsMutation, UpdateEventInfoSettingsMutationVariables>(UpdateEventInfoSettingsDocument, baseOptions);
}
export type UpdateEventInfoSettingsMutationHookResult = ReturnType<typeof useUpdateEventInfoSettingsMutation>;
export type UpdateEventInfoSettingsMutationResult = Apollo.MutationResult<UpdateEventInfoSettingsMutation>;
export type UpdateEventInfoSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateEventInfoSettingsMutation, UpdateEventInfoSettingsMutationVariables>;
export const GeneralSettingsInfoDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GeneralSettingsInfo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'domain' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'domainName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'admin' }, value: { kind: 'BooleanValue', value: true } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fianceeFirstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fianceeLastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ownerFirstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ownerLastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventDisplayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventDateIsFinalized' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locale' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'finalizedDate' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dateString' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tentativeDate' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dateString' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'locationInfo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'placeId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGeneralSettingsInfoQuery__
 *
 * To run a query within a React component, call `useGeneralSettingsInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneralSettingsInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneralSettingsInfoQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGeneralSettingsInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GeneralSettingsInfoQuery, GeneralSettingsInfoQueryVariables>) {
  return ApolloReactHooks.useQuery<GeneralSettingsInfoQuery, GeneralSettingsInfoQueryVariables>(GeneralSettingsInfoDocument, baseOptions);
}
export function useGeneralSettingsInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GeneralSettingsInfoQuery, GeneralSettingsInfoQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GeneralSettingsInfoQuery, GeneralSettingsInfoQueryVariables>(GeneralSettingsInfoDocument, baseOptions);
}
export type GeneralSettingsInfoQueryHookResult = ReturnType<typeof useGeneralSettingsInfoQuery>;
export type GeneralSettingsInfoLazyQueryHookResult = ReturnType<typeof useGeneralSettingsInfoLazyQuery>;
export type GeneralSettingsInfoQueryResult = Apollo.QueryResult<GeneralSettingsInfoQuery, GeneralSettingsInfoQueryVariables>;
export const SetEventAssetDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetEventAsset' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'setEventAssetId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SetAssetPayload' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isMobile' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setEventAsset' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'setEventAssetId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'isMobile' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'isMobile' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMobilePhoto' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mobilePhoto' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'container' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SetEventAssetMutationFn = Apollo.MutationFunction<SetEventAssetMutation, SetEventAssetMutationVariables>;

/**
 * __useSetEventAssetMutation__
 *
 * To run a mutation, you first call `useSetEventAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEventAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEventAssetMutation, { data, loading, error }] = useSetEventAssetMutation({
 *   variables: {
 *      setEventAssetId: // value for 'setEventAssetId'
 *      payload: // value for 'payload'
 *      isMobile: // value for 'isMobile'
 *   },
 * });
 */
export function useSetEventAssetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetEventAssetMutation, SetEventAssetMutationVariables>) {
  return ApolloReactHooks.useMutation<SetEventAssetMutation, SetEventAssetMutationVariables>(SetEventAssetDocument, baseOptions);
}
export type SetEventAssetMutationHookResult = ReturnType<typeof useSetEventAssetMutation>;
export type SetEventAssetMutationResult = Apollo.MutationResult<SetEventAssetMutation>;
export type SetEventAssetMutationOptions = Apollo.BaseMutationOptions<SetEventAssetMutation, SetEventAssetMutationVariables>;
export const DeleteEventAssetDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteEventAsset' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deleteEventAssetId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isMobile' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteEventAsset' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'deleteEventAssetId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'isMobile' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'isMobile' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMobilePhoto' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mobilePhoto' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'container' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DeleteEventAssetMutationFn = Apollo.MutationFunction<DeleteEventAssetMutation, DeleteEventAssetMutationVariables>;

/**
 * __useDeleteEventAssetMutation__
 *
 * To run a mutation, you first call `useDeleteEventAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventAssetMutation, { data, loading, error }] = useDeleteEventAssetMutation({
 *   variables: {
 *      deleteEventAssetId: // value for 'deleteEventAssetId'
 *      isMobile: // value for 'isMobile'
 *   },
 * });
 */
export function useDeleteEventAssetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteEventAssetMutation, DeleteEventAssetMutationVariables>) {
  return ApolloReactHooks.useMutation<DeleteEventAssetMutation, DeleteEventAssetMutationVariables>(DeleteEventAssetDocument, baseOptions);
}
export type DeleteEventAssetMutationHookResult = ReturnType<typeof useDeleteEventAssetMutation>;
export type DeleteEventAssetMutationResult = Apollo.MutationResult<DeleteEventAssetMutation>;
export type DeleteEventAssetMutationOptions = Apollo.BaseMutationOptions<DeleteEventAssetMutation, DeleteEventAssetMutationVariables>;
export const UpdateMainEventScheduleDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateMainEventSchedule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventInfoPayload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateEventInfoPayload' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'updateSettings' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventSettingsPayload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateEventSettingsPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateEventInfo' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventInfoPayload' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventDateIsFinalized' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tentativeDate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dateString' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finalizedDate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dateString' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setMainEventSchedule' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'scheduleId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateEventSettings' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventSettingsPayload' } } },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'updateSettings' } } }],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hideEventCountdown' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateMainEventScheduleMutationFn = Apollo.MutationFunction<UpdateMainEventScheduleMutation, UpdateMainEventScheduleMutationVariables>;

/**
 * __useUpdateMainEventScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateMainEventScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMainEventScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMainEventScheduleMutation, { data, loading, error }] = useUpdateMainEventScheduleMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      eventInfoPayload: // value for 'eventInfoPayload'
 *      scheduleId: // value for 'scheduleId'
 *      updateSettings: // value for 'updateSettings'
 *      eventSettingsPayload: // value for 'eventSettingsPayload'
 *   },
 * });
 */
export function useUpdateMainEventScheduleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMainEventScheduleMutation, UpdateMainEventScheduleMutationVariables>) {
  return ApolloReactHooks.useMutation<UpdateMainEventScheduleMutation, UpdateMainEventScheduleMutationVariables>(UpdateMainEventScheduleDocument, baseOptions);
}
export type UpdateMainEventScheduleMutationHookResult = ReturnType<typeof useUpdateMainEventScheduleMutation>;
export type UpdateMainEventScheduleMutationResult = Apollo.MutationResult<UpdateMainEventScheduleMutation>;
export type UpdateMainEventScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateMainEventScheduleMutation, UpdateMainEventScheduleMutationVariables>;
export const UpdateEventDateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateEventDate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateEventInfoPayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateEventInfo' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventDateIsFinalized' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tentativeDate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dateString' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finalizedDate' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dateString' } },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'timeString' },
                        name: { kind: 'Name', value: 'dateString' },
                        arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'timeFormat' }, value: { kind: 'EnumValue', value: 'time' } }],
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unsetMainEventSchedule' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type UpdateEventDateMutationFn = Apollo.MutationFunction<UpdateEventDateMutation, UpdateEventDateMutationVariables>;

/**
 * __useUpdateEventDateMutation__
 *
 * To run a mutation, you first call `useUpdateEventDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventDateMutation, { data, loading, error }] = useUpdateEventDateMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateEventDateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateEventDateMutation, UpdateEventDateMutationVariables>) {
  return ApolloReactHooks.useMutation<UpdateEventDateMutation, UpdateEventDateMutationVariables>(UpdateEventDateDocument, baseOptions);
}
export type UpdateEventDateMutationHookResult = ReturnType<typeof useUpdateEventDateMutation>;
export type UpdateEventDateMutationResult = Apollo.MutationResult<UpdateEventDateMutation>;
export type UpdateEventDateMutationOptions = Apollo.BaseMutationOptions<UpdateEventDateMutation, UpdateEventDateMutationVariables>;
export const SettingsPageContainerBySlugDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SettingsPageContainerBySlug' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventName' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageSlug' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'pageContainerBySlug' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'payload' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'eventName' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventName' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'pageSlug' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'pageSlug' } } },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: { kind: 'ObjectValue', fields: [{ kind: 'ObjectField', name: { kind: 'Name', value: 'admin' }, value: { kind: 'BooleanValue', value: true } }] },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'components' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'TravelSettingsMapComponent' } }] },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventName' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'travelSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'checkInDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'checkOutDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'datesMatchingReminder' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TravelSettingsMapComponent' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TravelMapComponent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sortOrder' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideExploreCTA' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSettingsPageContainerBySlugQuery__
 *
 * To run a query within a React component, call `useSettingsPageContainerBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsPageContainerBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingsPageContainerBySlugQuery({
 *   variables: {
 *      eventName: // value for 'eventName'
 *      pageSlug: // value for 'pageSlug'
 *   },
 * });
 */
export function useSettingsPageContainerBySlugQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SettingsPageContainerBySlugQuery, SettingsPageContainerBySlugQueryVariables>) {
  return ApolloReactHooks.useQuery<SettingsPageContainerBySlugQuery, SettingsPageContainerBySlugQueryVariables>(SettingsPageContainerBySlugDocument, baseOptions);
}
export function useSettingsPageContainerBySlugLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SettingsPageContainerBySlugQuery, SettingsPageContainerBySlugQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<SettingsPageContainerBySlugQuery, SettingsPageContainerBySlugQueryVariables>(SettingsPageContainerBySlugDocument, baseOptions);
}
export type SettingsPageContainerBySlugQueryHookResult = ReturnType<typeof useSettingsPageContainerBySlugQuery>;
export type SettingsPageContainerBySlugLazyQueryHookResult = ReturnType<typeof useSettingsPageContainerBySlugLazyQuery>;
export type SettingsPageContainerBySlugQueryResult = Apollo.QueryResult<SettingsPageContainerBySlugQuery, SettingsPageContainerBySlugQueryVariables>;
export const SetEventPhotoV2UrlMobileDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetEventPhotoV2UrlMobile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SetEventPhotoV2MobilePayload' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setEventPhotoV2UrlMobile' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'photoV2UrlMobile' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SetEventPhotoV2UrlMobileMutationFn = Apollo.MutationFunction<SetEventPhotoV2UrlMobileMutation, SetEventPhotoV2UrlMobileMutationVariables>;

/**
 * __useSetEventPhotoV2UrlMobileMutation__
 *
 * To run a mutation, you first call `useSetEventPhotoV2UrlMobileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEventPhotoV2UrlMobileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEventPhotoV2UrlMobileMutation, { data, loading, error }] = useSetEventPhotoV2UrlMobileMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetEventPhotoV2UrlMobileMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<SetEventPhotoV2UrlMobileMutation, SetEventPhotoV2UrlMobileMutationVariables>,
) {
  return ApolloReactHooks.useMutation<SetEventPhotoV2UrlMobileMutation, SetEventPhotoV2UrlMobileMutationVariables>(SetEventPhotoV2UrlMobileDocument, baseOptions);
}
export type SetEventPhotoV2UrlMobileMutationHookResult = ReturnType<typeof useSetEventPhotoV2UrlMobileMutation>;
export type SetEventPhotoV2UrlMobileMutationResult = Apollo.MutationResult<SetEventPhotoV2UrlMobileMutation>;
export type SetEventPhotoV2UrlMobileMutationOptions = Apollo.BaseMutationOptions<SetEventPhotoV2UrlMobileMutation, SetEventPhotoV2UrlMobileMutationVariables>;
